
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Megaphone } from 'lucide-react';
import AdRequestForm from './AdRequestForm';

interface AdRequestHeroProps {
  userData: any;
}

const AdRequestHero: React.FC<AdRequestHeroProps> = ({ userData }) => {
  return (
    <Card className="shadow-lg border-0 bg-white/80 backdrop-blur-sm">
      <CardHeader className="text-center pb-6">
        <div className="mx-auto w-16 h-16 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-full flex items-center justify-center mb-4">
          <Megaphone className="w-8 h-8 text-white" />
        </div>
        <CardTitle className="text-2xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
          Demande d'Annonce Publicitaire
        </CardTitle>
        <CardDescription className="text-lg text-gray-600">
          Soumettez votre demande pour recevoir nos offres d'annonces publicitaires personnalisées
        </CardDescription>
      </CardHeader>
      
      <CardContent>
        <AdRequestForm userData={userData} />
      </CardContent>
    </Card>
  );
};

export default AdRequestHero;
